import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useAppStore } from '@/dashboard/store/appStore';
import { storeToRefs } from 'pinia';
import { useLayoutStore } from '@/dashboard/store/layoutStore';

export function useHeaderMobile() {
  const appStore = useAppStore();
  const layoutStore = useLayoutStore();

  const { baseWorkspaceLink } = storeToRefs(appStore);

  function toggleSideMenu() {
    layoutStore.toggleOpenMainMenu();
  }

  return { baseWorkspaceLink, toggleSideMenu };
}
